import { Person,Home,Article,BarChart,AccountCircle} from '@mui/icons-material';

export const UpdatesData = [
    {
        img: 'profile.png',
        name: "Harsh",
        noti: "Great Service 👌. Prompt Diagnosis of the disease.",
        time: "25 seconds ago",
    },
    {
        img: 'profile.png',
        name: "Abhinav",
        noti: "Great Service 👌. Prompt Diagnosis of the disease.",
        time: "30 minutes ago",
    },
    {
        img: 'profile.png',
        name: "Raumil",
        noti: "Great Service 👌. Prompt Diagnosis of the disease.",
        time: "2 hours ago",
    },
];

export const SidebarData = [
    {
      icon: Home,
      heading: "Dashboard",
    },
    {
      icon: Article,
      heading: "Appointments",
    },
    {
      icon: Person,
      heading: "Patients",
    },
    {
      icon: AccountCircle,
      heading: 'Profile'
    },
    {
      icon: BarChart,
      heading: 'Analytics'
    },
  ];